<template>
    <v-layout>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex :class="showConnectors ? 'xs6' : '12'" v-if="!loading">
            <v-layout>
                <v-flex md4>
                    <v-card>
                        <v-card-text>
                            <v-layout row>
                                <v-text-field class="mr-4" prepend-icon="fa-filter" :placeholder="'Filter'|translate" v-model="search" clearable single-line/>
                                <v-spacer></v-spacer>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" :color="showConnectors ? 'success' : null" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Equipment')" @click="showConnectors=!showConnectors">fa-network-wired</v-icon>
                                    </template>
                                    <span>{{'Toggle Connectors'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Equipment')" @click="equipDialog=true">fa-plus</v-icon>
                                    </template>
                                    <span>{{'Add Equipment'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="uploadDialog=true">fa-file-upload</v-icon>
                                    </template>
                                    <span>{{'Upload Point List'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="multiUploadDialog=true">fa-upload</v-icon>
                                    </template>
                                    <span>{{'Upload Data'|translate}}</span>
                                </v-tooltip>
                                <maintenance-upload-dialog
                                    v-model="uploadDialog"
                                    v-if="uploadDialog"
                                    endpoint="/point-list-upload/"
                                    diff-options
                                    v-on:doreload="reloadTree(); uploadDialog=false"
                                    :title="'Point List upload'|translate"
                                    :upload-title="'Upload Point List CSV'|translate"
                                >
                                </maintenance-upload-dialog>
                                <maintenance-upload-dialog
                                    v-model="multiUploadDialog"
                                    v-if="multiUploadDialog"
                                    endpoint="/multiple-series-upload/"
                                    cleanup
                                    title="Data Upload"
                                    v-on:doreload="multiUploadDialog=false"
                                    upload-title="Upload CSV/Excel Data"
                                >
                                </maintenance-upload-dialog>
                                <equipment-record-dialog v-model="equipDialog" :item="{}" v-on:reloadequipments="reloadTree();equipDialog=false"></equipment-record-dialog>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-treeview :search="search2"
                                        :items="cleanedTree"
                                        :open.sync="open"
                                        item-key="id"
                            >
                                <template v-slot:label="{ item }">
                                    <span class="cursor-as-pointer pa-1" v-bind:class="{ 'v-treeview-node--active': selectedID&&selectedID===item.id }" @click="handleClick(item)">{{item.name}}</span>
                                </template>
                            </v-treeview>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex md8>
                    <v-card v-if="selectedItem" class="ml-3">
                        <v-card-title class="headline primary white--text" v-if="selectedType==='equipment'">
                            <v-icon small class="mr-2">fa-server</v-icon> {{selectedItem.equipment_name}}
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="dialog2=true">fa-plus</v-icon>
                                </template>
                                <span>{{'Add Point'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Equipment')" @click="dialog=true">fa-edit</v-icon>
                                </template>
                                <span>{{'Edit Equipment'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-2 cursor-as-pointer" v-if="$can('update', 'Equipment')" @click="deleteEquipment(selectedItem)">fa-trash</v-icon>
                                </template>
                                <span>{{'Delete Equipment'|translate}}</span>
                            </v-tooltip>
                            <equipment-record-dialog v-if="$can('update', 'Equipment')" v-model="dialog" :item="selectedItem" v-on:reloadequipments="reloadTree"></equipment-record-dialog>
                            <point-record-dialog v-if="$can('update', 'Points')" v-model="dialog2" :item="{'facility_name': facilityName,'equipment_name':selectedItem.equipment_name}" v-on:reloadpoints="reloadTree"></point-record-dialog>
                        </v-card-title>
                        <v-card-title class="headline primary white--text" v-if="selectedType==='sensor'">
                            <v-icon small class="mr-2">fa-wifi</v-icon> {{selectedItem.equipment_name}} > {{selectedItem.sensor_name}}
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="dialog2=true">fa-upload</v-icon>
                                </template>
                                <span>{{'Upload Data'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="dialog=true">fa-edit</v-icon>
                                </template>
                                <span>{{'Edit Point'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-2 cursor-as-pointer" v-if="$can('update', 'Points')" @click="deleteSensor(selectedItem)">fa-trash</v-icon>
                                </template>
                                <span>{{'Delete Point'|translate}}</span>
                            </v-tooltip>
                            <point-record-dialog v-if="$can('update', 'Points')" v-model="dialog" :item="selectedItem" v-on:reloadpoints="reloadTree"></point-record-dialog>
                            <maintenance-upload-dialog
                                v-model="dialog2"
                                v-if="dialog2&&selectedItem"
                                endpoint="/series-upload/"
                                cleanup
                                :sensor-id="selectedItem.sensor_id"
                                v-on:doreload="dialog2=false;"
                                :title="'Upload data for '+ facilityName+' - '+selectedItem.equipment_name+' - '+selectedItem.sensor_name"
                                :upload-title="'Upload CSV data for '+facilityName+' - '+selectedItem.equipment_name+' - '+selectedItem.sensor_name"
                            >
                            </maintenance-upload-dialog>
                        </v-card-title>
                        <v-card-text v-if="selectedType==='equipment'">
                            <v-layout>
                                <v-flex md6>
                                    <p v-if="selectedItem.equipment_id"><strong>{{'Equipment ID'|translate}} : </strong>{{selectedItem.equipment_id}}</p>
                                    <p v-if="selectedItem.equipment_name"><strong>{{'Equipment Name'|translate}} : </strong>{{selectedItem.equipment_name}}</p>
                                    <p v-if="selectedItem.equipment_type"><strong>{{'Equipment Type'|translate}} : </strong>{{selectedItem.equipment_type}}</p>
                                </v-flex>
                                <v-flex md6>
                                    <p v-if="selectedItem.floor"><strong>{{'Floor'|translate}} : </strong>{{selectedItem.floor}}</p>
                                    <p v-if="selectedItem.notes"><strong>{{'Notes'|translate}} : </strong>{{selectedItem.notes}}</p>
                                </v-flex>
                            </v-layout>
                            <data3-chart v-for="plot in plotConfig"
                                         :layout-overrides="plot['layout-overrides']"
                                         :on-only="false"
                                         :x-axis="plot['x-axis']"
                                         :y-axis="plot['y-axis']"
                                         :color-axis="plot['color-axis']"
                                         :color-axis-scale="plot['color-axis-scale']"
                                         :color-axis-title="plot['color-axis-title']"
                                         disable-responsive
                                         show-units
                                         :data-payload="plot['data-payload']"
                                         :series-overrides="plot['series-overrides']"
                                         :date-range="range"></data3-chart>
                        </v-card-text>
                        <v-card-text v-if="selectedType==='sensor'">
                            <v-layout>
                                <v-flex md6>
                                    <p v-if="selectedItem.sensor_id"><strong>{{'Sensor ID'|translate}} : </strong>{{selectedItem.sensor_id}}</p>
                                    <p v-if="selectedItem.sensor_name"><strong>{{'Sensor Name'|translate}} : </strong>{{selectedItem.sensor_name}}</p>
                                    <p v-if="selectedItem.sensor_name_abbr"><strong>{{'Sensor Name Abbr'|translate}} : </strong>{{selectedItem.sensor_name_abbr}}</p>
                                    <p v-if="selectedItem.equipment_name"><strong>{{'Equipment Name'|translate}} : </strong>{{selectedItem.equipment_name}}</p>
                                    <p v-if="selectedItem.unit"><strong>{{'Unit'|translate}} : </strong>{{selectedItem.unit}}</p>
                                </v-flex>
                                <v-flex md6>
                                    <p><strong>{{'Faulty'|translate}} : </strong> {{selectedItem.faulty ? 'yes' : 'no'|translate}}</p>
                                    <p v-if="selectedItem.connector_id"><strong>{{'Connector'|translate}} : </strong>{{getConnectorInfo(selectedItem.connector_id)}}</p>
                                    <p v-if="selectedItem.haystack_id"><strong>{{'Upstream ID'|translate}} : </strong>{{selectedItem.haystack_id}}</p>
                                    <p v-if="selectedItem.sensor_desc"><strong>{{'Sensor Description'|translate}} : </strong>{{selectedItem.sensor_desc}}</p>
                                    <p v-if="selectedItem.weight"><strong>{{'Weight'|translate}} : </strong>{{selectedItem.weight}}</p>
                                </v-flex>
                            </v-layout>
                            <data3-chart v-if="plotConfig"
                                         :layout-overrides="plotConfig['layout-overrides']"
                                         :on-only="false"
                                         :x-axis="plotConfig['x-axis']"
                                         :y-axis="plotConfig['y-axis']"
                                         :color-axis="plotConfig['color-axis']"
                                         :color-axis-scale="plotConfig['color-axis-scale']"
                                         :color-axis-title="plotConfig['color-axis-title']"
                                         disable-responsive
                                         show-units
                                         :data-payload="plotConfig['data-payload']"
                                         :series-overrides="plotConfig['series-overrides']"
                                         :date-range="range"></data3-chart>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs6 v-if="showConnectors">
            <connectors class="ml-3" side-mode :mappedext="mappedIds" :equipment-name="selectedItem&&selectedItem.equipment_name ? selectedItem.equipment_name : null" @addpoint="addFromConnector"></connectors>
            <point-record-dialog v-if="$can('update', 'Points')" v-model="dialog3" :item="itemFromConnector" v-on:reloadpoints="reloadTree"></point-record-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import {getEquipment, deleteEquipment, getPoint, deletePoint, sortFloors, getConnector} from '../helper'
import EquipmentRecordDialog from '../components/equipment/EquipmentRecordDialog'
import PointRecordDialog from '../components/points/PointRecordDialog'
import Data3Chart from "../components/Data3Chart";
import DateRangeSelector from "../components/DateRangeSelector";
import moment from 'moment'
import MaintenanceUploadDialog from "../components/maintenance/MaintenanceUploadDialog";
import Connectors from "./Connectors";

export default {
    name: 'Builder',
  components: { EquipmentRecordDialog, PointRecordDialog,Data3Chart,DateRangeSelector,MaintenanceUploadDialog,Connectors},
  data: () => ({
      loading: true,
      open:[],
      search:null,
      search2:null,
      itemFromConnector:null,
      showConnectors:false,
      dialog:false,
      dialog2:false,
      dialog3:false,
      uploadDialog:false,
      mappedIds:[],
      multiUploadDialog:false,
      connectors:[],
      equipDialog:false,
      tree:null,
      timeout:null,
      selectedItem:null,
      selectedID:null,
      selectedType:null,
      selectedItemChildren:null,
      range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
    }),

  mounted() {
    this.reloadTree()
  },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    async beforeMount() {
        let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
        let rangeStart = _.get(this.$route.query, 'rangeStart', null)
        let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
        if (!!rangeStart) {
            this.range = {start: rangeStart, end: rangeEnd}
        } else if (maxDate) {
            this.range = {
                start: moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),
                end: moment(maxDate).format('YYYY-MM-DD')
            }
        }
        let df = await getConnector({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.connectors = df['result']
    },
    computed: {
        facilityName(){
            return this.$store.state.pointsListStore.pointsList.facility_name;
        },
        cleanedTree() {
            return JSON.parse(JSON.stringify(this.tree)) //this is just here to scrap observers and not kill tree performance
        },
        plotConfig(){
            if (this.selectedType&&this.selectedType==='sensor'){
                return  {
                    'layout-overrides': {
                        title:"",
                        colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                        xaxis: {
                            title: this.$options.filters.translate("Time")
                        },
                        yaxis: {
                            title: this.selectedItem.unit
                        },
                        zaxis: {
                            title: null
                        },
                        showlegend:true,
                        height:300,
                        hovermode:"x",
                        margin:{
                            l: 50,
                            r: 50,
                            t: 50,
                            pad: 1
                        },
                        legend: {
                            orientation: 'h',
                            y: -0.3
                        },
                    },
                    "x-axis":"timestamp",
                    "y-axis":null,
                    "color-axis":null,
                    "color-axis-scale":null,
                    "color-axis-title":null,
                    'data-payload': [{
                        'filters': {
                            equipment_name: this.selectedItem.equipment_name,
                            sensor_name: this.selectedItem.sensor_name,
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        },
                        seriesOverrides:{
                            type:'scatter',
                            opacity:1,
                            xbins: {
                                size: 1
                            },
                            ybins: {
                                size: 1
                            }
                        },
                    }],
                }
            } else if (this.selectedType&&this.selectedType==='equipment'&&this.selectedItemChildren){
                let newVarList={};
                for (let sensor of this.selectedItemChildren){
                    let unit = sensor.itemData.unit ? sensor.itemData.unit : ""
                    if (!newVarList[unit]) {
                        newVarList[unit] = [];
                    }
                    newVarList[unit].push({
                        equipment_name: this.selectedItem.equipment_name,
                        name: sensor.itemData.sensor_name,
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    })
                }
                return(Object.keys(newVarList).map(unit=>{
                    return  {
                        'layout-overrides': {
                            title:"",
                            colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                            xaxis: {
                                title: this.$options.filters.translate("Time")
                            },
                            yaxis: {
                                title: unit
                            },
                            zaxis: {
                                title: null
                            },
                            showlegend:true,
                            height:300,
                            hovermode:"x",
                            margin:{
                                l: 50,
                                r: 50,
                                t: 50,
                                pad: 1
                            },
                            legend: {
                                orientation: 'h',
                                y: -0.3
                            },
                        },
                        "x-axis":"timestamp",
                        "y-axis":null,
                        "color-axis":null,
                        "color-axis-scale":null,
                        "color-axis-title":null,
                        'data-payload': newVarList[unit].map(function (selectedVar) {
                            let premap={
                                'filters': {
                                    equipment_name: selectedVar.equipment_name,
                                    sensor_name: selectedVar.name,
                                    facility_name: selectedVar.facility_name,
                                },
                                seriesOverrides:{
                                    type:'scatter',
                                    opacity:1,
                                    xbins: {
                                        size: 1
                                    }
                                },
                                pipeline:[]
                            }

                            return (premap)
                        }),
                    }
                }))
            } else {
                return null
            }
        }
    },
    methods: {
        getConnectorInfo(id){
            let found=this.connectors.filter(x=>x.connector_id===id)
            if (found&&found[0]){
                return found[0].type+ " - "+found[0].name
            }
            return id
        },
        addFromConnector(item){
            this.itemFromConnector=item
            this.dialog3=true
        },
        async deleteSensor (sensor) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this sensor?')) ){
                await deletePoint({
                    'sensor_id': sensor.sensor_id
                })
                this.clearSelection()
                this.reloadTree()
            }
        },
        async deleteEquipment (equipment) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this equipment?')) ){
                await deleteEquipment({
                    'equipment_id': equipment.equipment_id
                })
                this.clearSelection()
                this.reloadTree()
            }
        },
        handleClick(item){
            if(!item.itemType||!item.itemData){
                this.clearSelection()
            } else {
                this.selectItem(item.itemType,item.itemData,item.id,item.children)
            }
        },
        selectItem(type,item,id,children){
            this.dialog=false
            this.dialog2=false
            this.selectedType=type
            this.selectedItem=item
            this.selectedItemChildren=children
            this.selectedID=id
        },
        clearSelection(){
            this.dialog=false
            this.dialog2=false
            this.selectedType=null
            this.selectedItem=null
            this.selectedItemChildren=null
            this.selectedID=null
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        arrangeIntoTree(paths,childrenList,equipDetails) {
            let tree = [];
            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];
                let currentLevel = tree;
                for (let j = 0; j < path.length; j++) {
                    let part = path[j];
                    let existingPath = this.findWhere(currentLevel, 'name', part);
                    if (existingPath) {
                        currentLevel = existingPath.children;
                    } else {
                        let newPart = {
                            name: part,
                            id: path.join('-')+'-'+part,
                            children: [],
                        }
                        if(equipDetails[part]){
                            newPart.itemType="equipment"
                            newPart.itemData=equipDetails[part]
                        }
                        if(childrenList[part]){
                            newPart.children=childrenList[part]
                        }
                        currentLevel.push(newPart);
                        currentLevel = newPart.children;
                    }
                }
            }
            return tree;
        },
        findWhere(array, key, value) {
            let t = 0;
            while (t < array.length && array[t][key] !== value) {
                t++;
            }
            if (t < array.length) {
                return array[t]
            } else {
                return false;
            }
        },
      async reloadTree() {
          this.loading=true
          this.dialog=false
          this.dialog2=false
          this.dialog3=false
          let facilityName=this.$store.state.pointsListStore.pointsList.facility_name
          let equipsDF = await getEquipment({
              facility_name: facilityName
          })
          let pointsDF = await getPoint({
              facility_name: facilityName
          })
          this.mappedIds = pointsDF['result'].map(x=>{return {haystack_id:x.haystack_id,connector_id:x.connector_id}})
          let childrenList=[]
          let equipDetails=[]
          for(let equipment of equipsDF.result){
              let points=pointsDF.result.filter(x=>x.equipment_id&&x.equipment_id===equipment.equipment_id).map(x=>{return{
                  id:x.sensor_id,
                  name:x.sensor_name,
                  children: [],
                  equipment_name:equipment.equipment_name,
                  facility_name:facilityName,
                  itemType:"sensor",
                  itemData:x,
              }})
              points.sort((a, b) => (a.name > b.name) ? 1 : -1)
              childrenList[equipment.equipment_name]=points
              equipDetails[equipment.equipment_name]=equipment
          }
          equipsDF.result.sort((a, b) => (a.equipment_name > b.equipment_name) ? 1 : -1)
          let equipPaths=[];
          for (let equip of equipsDF.result){
              let newPath=[]
              if(equip.floor&&equip.floor!==""&&equip.floor!=="NaN"){
                  newPath=equip.floor.split('>').concat([equip.equipment_name])
              } else if (equip.equipment_type&&equip.equipment_type!==""&&equip.equipment_type!==equip.equipment_name){
                  newPath=[equip.equipment_type,equip.equipment_name]
              } else {
                  newPath=[equip.equipment_name]
              }
              if(newPath.length>1){
                  for (let index=0; index<newPath.length; index++){
                      if(index<newPath.length&&newPath[index]===newPath[index+1]){
                          newPath[index]=newPath[index]+" "
                      }
                  }
              }
              equipPaths.push(newPath)
          }
          equipPaths=sortFloors(equipPaths)
          this.tree=this.arrangeIntoTree(equipPaths,childrenList,equipDetails);
          this.loading=false
      }
    }
  }
</script>

<style scoped>
.cursor-as-pointer{
    cursor: pointer !important;
}
</style>
